module.exports = __webpack_public_path__ + "img/mourning-1.fe3788d8.webp";